import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import { MessagesModal } from '../Components';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'Messages'>;

const MessagesScreen: React.FC<Props> = ({ navigation }) => {
	return (
		<MessagesModal
			onClose={() => {
				if (navigation.canGoBack()) {
					navigation.goBack();
				} else {
					navigation.navigate('Main');
				}
			}}
			onOpenFriendRequests={() => navigation.replace('Inventory', { tab: 'friends' })}
		/>
	);
};

export default MessagesScreen;
